import React, { useState } from 'react';
import { clone } from 'lodash-es';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { getValidationError } from '../../helpers/dataOperations/form/validationMessageHelper';
import useChangePasswordHook from '../hooks/usePasswordChangeHook';
import validateEditorState from './validateEditorState';
import initialEditorState from './initialEditorState';
import FormNotification from '../../shared/components/formNotification';
import { setFormMessage, setSelectedForm } from '../../unauthorizedState/actions'; // eslint-disable-line
import { FORMS__SIGN_IN } from '../../unauthorizedState/constants';

const PasswordChangeForm = () => {
  const dispatch = useDispatch();
  const urlParams = useParams();
  const navigate = useNavigate();

  const [editorState, setEditorState] = useState(initialEditorState());
  const [validationMessage, setValidationMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const { changePassword, isSending } = useChangePasswordHook();

  const onChange = (propertyName, value) => {
    if (!isSending) {
      const currentEditorState = clone(editorState);
      currentEditorState[propertyName] = value;

      setEditorState(currentEditorState);
    }
  };

  const onChangePasswordSuccess = () => {
    dispatch(setFormMessage(''));
    navigate('/', { state: { changePassword: true }});
    dispatch(setSelectedForm(FORMS__SIGN_IN));
  };

  const onChangePasswordError = (apiErrorMessage) => {
    setErrorMessage(apiErrorMessage);
  };

  const passwordChangeButtonClick = () => {
    const validateMessage = validateEditorState(editorState);

    if (validateMessage) {
      setValidationMessage(validateMessage);
    } else {
      setValidationMessage(null);
      changePassword(
        editorState.password,
        urlParams?.token,
        onChangePasswordSuccess,
        onChangePasswordError,
      );
    }
  };

  const onFormClick = (event) => {
    if (event.key === 'Enter') {
      passwordChangeButtonClick();
    }
  };

  return (
    <div className="password-change">
      <If condition={errorMessage}>
        <FormNotification message={errorMessage} />
      </If>
      <div className="title">
        Zmiana Hasła
      </div>
      <div className="description">
        Podaj nowe hasło do swojego konta.
      </div>
      <div className="form" role="button" onKeyDown={onFormClick}>
        <div className="form-group">
          <div className="error-message">
            {getValidationError(validationMessage, 'password')}
          </div>
          <label htmlFor="password">
            Hasło
            <input
              className="form-control"
              id="password"
              type="password"
              value={editorState.password}
              onChange={(event) => onChange('password', event.target.value)}
            />
          </label>
        </div>
        <div className="form-group form-group-separated">
          <div className="error-message">
            {getValidationError(validationMessage, 'passwordConfirm')}
          </div>
          <label htmlFor="passwordConfirm">
            Powtórz hasło
            <input
              className="form-control"
              id="passwordConfirm"
              type="password"
              value={editorState.passwordConfirm}
              onChange={(event) => onChange('passwordConfirm', event.target.value)}
            />
          </label>
        </div>
        <div className="actions">
          <Choose>
            <When condition={isSending}>
              <div className="button password-change-button spinner-wrapper">
                <div className="spinner-border text-light" role="status" />
              </div>
            </When>
            <Otherwise>
              <div
                className="button password-change-button"
                onClick={passwordChangeButtonClick}
                role="button"
                title="Potwierdź"
              >
                Potwierdź
              </div>
            </Otherwise>
          </Choose>
        </div>
      </div>
    </div>
  );
};

export default PasswordChangeForm;
